/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetGuardrailsRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetGuardrailsRequest$inboundSchema: z.ZodType<
  GetGuardrailsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetGuardrailsRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetGuardrailsRequest$outboundSchema: z.ZodType<
  GetGuardrailsRequest$Outbound,
  z.ZodTypeDef,
  GetGuardrailsRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getGuardrailsRequestToJSON(
  getGuardrailsRequest: GetGuardrailsRequest,
): string {
  return JSON.stringify(
    GetGuardrailsRequest$outboundSchema.parse(getGuardrailsRequest),
  );
}
export function getGuardrailsRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetGuardrailsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetGuardrailsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetGuardrailsRequest' from JSON`,
  );
}
